"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Consumer = exports.Provider = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var ThemeContext = (0, _react.createContext)();
var Consumer = ThemeContext.Consumer;
exports.Consumer = Consumer;

var Provider = function Provider(_ref) {
  var children = _ref.children,
      themes = _ref.themes,
      _ref$onUpdate = _ref.onUpdate,
      onUpdate = _ref$onUpdate === void 0 ? function (_ref2) {
    var theme = _ref2.theme,
        prevTheme = _ref2.prevTheme;
  } : _ref$onUpdate,
      _ref$persistTheme = _ref.persistTheme,
      persistTheme = _ref$persistTheme === void 0 ? true : _ref$persistTheme,
      _ref$transformTheme = _ref.transformTheme,
      transformTheme = _ref$transformTheme === void 0 ? function (theme) {
    return theme.config;
  } : _ref$transformTheme;

  var _useState = (0, _react.useState)(getInitialTheme()),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      theme = _useState2[0],
      updateTheme = _useState2[1];

  (0, _react.useEffect)(function () {
    var localTheme = getInitialTheme();
    persistToLocalStorage(localTheme);
    onUpdate({
      theme: localTheme,
      prevTheme: null
    });
  }, []);
  /**
   * Get the initial theme by first searching localStorage when
   * persistTheme is true, falling back to the first theme in the
   * themes array
   *
   * @returns {String} Theme key
   */

  function getInitialTheme() {
    var theme;
    if (persistTheme && global.window && global.window.localStorage && global.window.localStorage.getItem) theme = global.window.localStorage.getItem('theme') || '';
    return isValidTheme(theme) ? theme : themes[0].key;
  }
  /**
   * Persists the theme to local storage if persistTheme is true
   *
   * @param {String} theme
   * @returns {Void}
   */


  function persistToLocalStorage(theme) {
    if (persistTheme && global.window && global.window.localStorage && global.window.localStorage.setItem) global.window.localStorage.setItem('theme', theme);
  }
  /**
   * Checks if a theme exists i.e. is valid
   *
   * @param {String} theme Theme key
   * @returns {Boolean}
   */


  function isValidTheme(theme) {
    return Boolean(themes.filter(function (_ref3) {
      var key = _ref3.key;
      return key === theme;
    }).shift());
  }
  /**
   * Sets a new theme, will do nothing when setting the same theme
   *
   * @param {String} newTheme Theme key
   * @returns {Void}
   */


  function setTheme(newTheme) {
    if (newTheme === theme) return;
    if (!isValidTheme(newTheme)) throw new Error("Theme ".concat(newTheme, " does not exist"));
    persistToLocalStorage(newTheme);
    onUpdate({
      theme: newTheme,
      prevTheme: theme
    });
    updateTheme(newTheme);
  }
  /**
   * Gets the theme configuration for the theme key (untransformed)
   *
   * @returns {Object}
   */


  function getOriginalTheme() {
    return themes.filter(function (_ref4) {
      var key = _ref4.key;
      return key === theme;
    }).shift() || {};
  }
  /**
   * Gets the theme configuration for the theme key (transformed)
   *
   * @returns {Object}
   */


  function getTheme() {
    return transformTheme(getOriginalTheme());
  }

  return _react["default"].createElement(ThemeContext.Provider, {
    value: {
      key: theme,
      theme: getTheme(),
      originalTheme: getOriginalTheme(),
      setTheme: setTheme,
      themes: themes
    }
  }, children);
};

exports.Provider = Provider;
Provider.propTypes = {
  children: _propTypes["default"].any,
  themes: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    key: _propTypes["default"].string.isRequired,
    config: _propTypes["default"].object.isRequired
  })).isRequired,
  onUpdate: _propTypes["default"].func,
  persistTheme: _propTypes["default"].bool,
  transformTheme: _propTypes["default"].func
};
var _default = {
  Provider: Provider,
  Consumer: Consumer
};
exports["default"] = _default;